import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin({
    name: 'ssr-payload',
    parallel: true,
    async setup(nuxtApp) {
        nuxtApp.hook('app:rendered', (context) => {
            if (context.ssrContext?.error === false) {
                context.ssrContext.nuxt.runWithContext(() => {
                    const route = useRoute();

                    if (context.ssrContext) {
                        context.ssrContext.event.context.appSSRPayload = {
                            route
                        };
                    }
                });
            }
        });
    }
});
